import { LOGIN_RESULT } from '../user/actions'
import { BET_PLACED, ANSWER_PROCESSED } from '../userAnswer/actions'
import { STARTED_MATCH } from '../matches'
import {CHANGED_USER_POINTS} from '../userPoints'

export const balance = (state = 0, action) => {
    switch (action.type) {
        case ANSWER_PROCESSED:
            return action.user_answer.new_balance

        case CHANGED_USER_POINTS:
                return action.balance
        
        case BET_PLACED:
        case LOGIN_RESULT:
            if (action.error)
                return state
            return typeof action.balance === 'undefined' ? state : action.balance

        case STARTED_MATCH:
            return action.match.balance

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/balance/index.js